import LOADING from "./loading";
import NOTFOUND from "./not-found";
// import './youtube'

export default {
  loading: LOADING,
  "not-found": NOTFOUND,
};
